<template>
    <div>
        <h3 class="f-18 text-left mb-3 font-weight-bold mt-4">{{ $t('register.loadSampleDataTitle') }}</h3>
        <p class="mb-3 f-14 text-left">{{ $t('register.loadSampleDataDescription') }}</p>
            <div class="d-flex align-items-center justify-space-between gap-3">
        <b-button class="w-100 mt-3 login h-40px" variant="primary" @click="loadSampleData()">{{ $t('register.yes') }}</b-button>
        <b-button variant="secondary" class="mt-3 w-100 h-40px" @click="goToCompanyPage()">{{ $t('register.no') }}</b-button>
    </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: "Step5",
    props: ['companyID'],
    methods: {
        ...mapActions(['setLoader', "loadCompanySampleData", "setNotification"]),
        goToCompanyPage() {
            this.$router.push("/all-companies");
        },
        async loadSampleData() {
            try {
                this.setLoader(true);
                await this.loadCompanySampleData({ company: this.companyID });
                await this.setNotification({
                    msg: this.$t('register.notifications.sampleDataImported'),
                    type: "success",
                    color: "green",
                });
                this.goToCompanyPage()
                this.setLoader(false);
            }
            catch (e) {
                this.setLoader(false);

            }
        },
    }
}
</script>
